var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.nameText},[_c('div',{attrs:{"data-test-id":"CommandTemplateName__NameText"}},[_vm._v(" "+_vm._s(_vm.templateNameText)+" ")]),_c('div',{class:_vm.$style.subtitleStyle,attrs:{"data-test-id":"CommandTemplateName__NameSubText"}},[_vm._v(" "+_vm._s(_vm.templateNameSubtext)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }